<div class="modal-body height-900">
  <div class="layout-auto-1-auto">
    <span class="modal-header" style="margin-bottom: 0;">
      {{getRessource("ModalHeader")}}
      <exg-select *ngIf="this.config.wAnsprSelect.showSelect"
                  [ngModel]="this.config.wAnsprSelect.selectedIndex"
                  [caption]="getRessource('SelectCaption')"
                  (ngModelChange)="this.config.wAnsprSelect.selectionChanged($event)"
                  listdisplay="enmText" name="enmText"
                  [list]="this.wAnsprSelect.data" caption="{{getRessource('SelectListCaption')}}" name="{{getRessource('SelectListNameCaption')}}"></exg-select>
    </span>
    <div class="content layout-auto-1-auto width-1000">
        <exg-search-bar (Search)="config.oeList.search($event)" [placeholder]="getRessource('SearchPlaceholder')"
                        class="span-layout" style="z-index: 7">
          <ng-template #rightTemplate>
            <i (click)="config.oeList.loadData()" class="search-action far fa-sync"></i>

            <i class="search-action fal fa-gears"
               (click)="openTableSettings($event)">
            </i>
            <exg-table-settings #tableDefinitionSettings
                                [tableDef]="oeList.tableDef"
                                [metaInfo]="oeList.MetaInfo"
                                localStorageID="chooseOeTable">
            </exg-table-settings>
          </ng-template>
        </exg-search-bar>
        <div class="content">
          <exg-table #oeTable
                     (RowDblClick)="config.oeList.selectionChanged($event)"
                     (RowChange)="config.oeList.selectionChanged($event)" (FilterActivation)="config.oeList.loadData()"
                     [selectKey]="'oeID'" [rowSource]="oeList.data" [distinctTableName]="'Dealer'"
                     [displayState]="config.oeList.state" class="content"
                     [allowSingleSelection]="true" [allowMultiSelection]="false"
                     [metaInfo]="oeList.MetaInfo"
                     (loadDistinct)="getDistinctOE($event)"
                     [tableDef]="oeList.tableDef"
                     [distinctData]="oeList.distinctData"></exg-table>
        </div>
        <exg-pager (PageChange)="config.oeList.pageChanged($event)" *ngIf="true"
                   [pagingSource]="oeList.paging"
                   class="span-layout app-pager">
        </exg-pager>
    </div>
    <div class="spawn-modal-actions">
      <button class="md-btn" (click)="clickedSave()">{{getGlobal('Save')}}</button>
      <button class="md-btn" (click)="clickedCancel()">{{getGlobal('Cancel')}}</button>
    </div>
  </div>
</div>
